import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateProject from '../CreateProject/CreateProject';
import '../ProjectList/ProjectList.css';
import MenuItem from '@mui/material/MenuItem';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import { fetchProjectList, deleteProject } from '../../store/app/apis';
import Toast from 'light-toast';
import { getTime } from '../../utils';
import TablePagination from '@mui/material/TablePagination';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export function ProjectList({ projectList, isMobile, projectCount, fetchProjectList, deleteProject }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchorEl, setmenuAnchorEl] = useState(null);
  const open = Boolean(menuAnchorEl);
  const [page, setPage] = useState(0);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [id, setId] = useState('');
  let navigate = useNavigate();
  const getProjectDetailPage = (event, id) => {
    navigate(`/dashboard/projectdetails/${id}`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleDialog = () => {
    setmenuAnchorEl(null);
    setOpenConfirmationDialog(true);
  };

  const handleClose = (issuccess) => {
    setOpenConfirmationDialog(false);
    if (issuccess) {
      deleteProject(id);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleClick = (event, id) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setmenuAnchorEl(null);
    setId(id);
  };

  const handleMenu = (event, id) => {
    setmenuAnchorEl(event.currentTarget);
    setId(id);
  };

  const copyToClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
        setmenuAnchorEl(null);
      })
      .catch((error) => {
        Toast.fail('Text not copied!');
        setmenuAnchorEl(null);
      });
  };
  const styles = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
  };
  useEffect(() => {
    var payload = {};
    payload['page'] = page + 1;
    payload['size'] = rowsPerPage;
    fetchProjectList(payload);
  }, [page, rowsPerPage]);

  return (
    <>
      <div className="completeTable">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Project Name</th>
              <th>Hook ID</th>
              <th>CT</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projectList?.map((project) => (
              <tr key={project?.id}>
                <td
                  onClick={(event) => getProjectDetailPage(event, project?.id, project?.title)}
                  style={{ textAlign: 'left', paddingLeft: '25px', color: 'blue' }}
                >
                  {project?.title}
                </td>
                <td>{project?.hookid} </td>
                <td>{getTime(project?.ct)}</td>
                <td>
                  <MoreVertIcon onClick={(event) => handleMenu(event, project?.id)} sx={{ cursor: 'pointer' }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Menu
          id="profile-item-menu"
          anchorEl={menuAnchorEl}
          onClose={() => setmenuAnchorEl(null)}
          open={open}
          variant="selectedMenu"
        >
          <MenuItem value={10}>
            <button onClick={() => handleDialog()} className="iconsText">
              <DeleteIcon />
              Delete
            </button>
          </MenuItem>
          <MenuItem value={20}>
            <button onClick={(event) => handleClick(event, id)} className="iconsText">
              <EditIcon />
              Edit
            </button>
          </MenuItem>
          <MenuItem value={30}>
            <button
              onClick={() => copyToClipboard(projectList?.filter((project) => project.id === id)[0]['id'])}
              className="iconsText"
            >
              <ContentCopyIcon />
              copy
            </button>
          </MenuItem>
        </Menu>
        <TablePagination
          rowsPerPageOptions={[10, 15, 25, 50, 100]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          count={projectCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          sx={styles}
        />
        {anchorEl && <CreateProject anchorEl={anchorEl} id={id} onClose={handleClick} />}
        {openConfirmationDialog && <ConfirmationDialog closedialog={handleClose} />}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
  projectCount: state.app.projectCount,
  isMobile: state.app.isMobile,
});
const mapDispatchToProps = { fetchProjectList, deleteProject };

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);
